module.exports = __webpack_public_path__ + "static/img/lusexi.3252b8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lusexi.png
// module id = Gs7L
// module chunks = 3